module.exports = __webpack_public_path__ + "img/ELECTORAL.3bbae05a.jpg";